// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.branch-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  background-color: #f8f9fa;
  padding: 15px;
  margin-top: 1rem;
}
.branch-container .branch-card {
  background-color: white;
  border: 1px solid #c4c4c4;
  border-radius: 0.3rem;
  padding: 1.5rem;
  cursor: pointer;
}
.branch-container .branch-card .branch-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0;
}
.branch-container .branch-card .branch-header .branch-title-wrapper {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}
.branch-container .branch-card .branch-header .branch-title-wrapper .branch-label {
  background-color: #e5e7eb;
  color: #374151;
  font-size: 0.75rem;
  font-weight: 500;
  padding: 0.2rem 0.5rem;
  border-radius: 0.25rem;
  width: fit-content;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.branch-container .branch-card .branch-header .branch-title-wrapper .branch-name {
  font-size: 1.2rem;
  font-weight: 700;
  color: #1f2937;
  position: relative;
}
.branch-container .branch-card .branch-header .branch-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  justify-content: flex-end;
}
.branch-container .branch-card .branch-header .branch-actions .branch-action-btn {
  color: black;
  border: none;
  border-radius: 9999px;
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.2s;
}
.branch-container .branch-card .branch-header .branch-actions .edit-branch {
  margin-right: 0.5rem;
  padding: 0.3rem 0.6rem;
  font-size: 0.85rem;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}
.branch-container .branch-card .branch-header .branch-actions .edit-branch:hover {
  background-color: #f8f9fa;
  opacity: 0.9;
}
.branch-container .branch-card .branch-header .branch-actions .manual-add,
.branch-container .branch-card .branch-header .branch-actions .spreadsheet-add,
.branch-container .branch-card .branch-header .branch-actions .members-action {
  border-radius: 0.375rem;
  padding: 0.4rem 0.75rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  height: auto;
  width: auto;
}
.branch-container .branch-card .branch-header .branch-actions .manual-add {
  background-color: #2E8B57;
}
.branch-container .branch-card .branch-header .branch-actions .spreadsheet-add {
  background-color: var(--primary-color);
}
.branch-container .branch-card .branch-header .branch-actions .members-action {
  background-color: var(--primary-color);
  transition: opacity 0.2s ease;
}
.branch-container .branch-card .branch-header .branch-actions .members-action:hover {
  opacity: 0.9;
}
.branch-container .branch-card .branch-meta {
  margin-top: 0.5rem;
  font-size: 0.875rem;
  color: #6b7280;
}
.branch-container .branch-card .branch-meta .branch-detail-value {
  color: #135bc0;
  font-weight: 600;
}
.branch-container .branch-card .branch-meta .branch-meta-separator {
  display: inline-block;
  width: 24px;
}
.branch-container .branch-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(900px, 1fr));
  gap: 1rem;
  margin-top: 1rem;
}
.branch-container .branch-table {
  width: 100%;
  border-collapse: collapse;
  background-color: var(--card-bg);
  border: 1px solid var(--border-color);
  border-radius: 0.5rem;
  overflow: hidden;
  box-shadow: 0 2px 6px var(--shadow-light);
  font-size: 0.95rem;
}
.branch-container .branch-table thead {
  background-color: #f1f5f9;
}
.branch-container .branch-table thead th {
  text-align: left;
  padding: 1rem;
  color: var(--text-color-dark);
  font-weight: 600;
  border-bottom: 1px solid var(--border-color);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-size: 0.85rem;
}
.branch-container .branch-table tbody tr {
  transition: background-color 0.2s ease;
}
.branch-container .branch-table tbody tr:hover {
  background-color: #f9fafb;
}
.branch-container .branch-table tbody tr td {
  padding: 0.9rem 1rem;
  color: var(--text-color-medium);
  border-bottom: 1px solid var(--border-color);
}
.branch-container .branch-table tbody tr td.bold {
  color: var(--text-color-dark);
  font-weight: 600;
}
.branch-container .branch-table tbody tr td.highlight {
  color: var(--accent-color);
  font-weight: 700;
}
.branch-container .branch-table tbody tr td:last-child {
  white-space: nowrap;
}
.branch-container .branch-table tbody tr td:last-child button {
  margin-left: 0.3rem;
  padding: 0.35rem 0.7rem;
  font-size: 0.8rem;
  border-radius: 0.375rem;
  border: none;
  cursor: pointer;
  transition: background-color 0.2s ease;
}
.branch-container .branch-table tbody tr td:last-child button.edit-btn {
  background-color: #17a2b8;
  color: white;
}
.branch-container .branch-table tbody tr td:last-child button.edit-btn:hover {
  opacity: 0.9;
}
.branch-container .branch-table tbody tr td:last-child button.manual-btn {
  background-color: #2E8B57;
  color: white;
}
.branch-container .branch-table tbody tr td:last-child button.spreadsheet-btn {
  background-color: var(--primary-color);
  color: white;
}
.branch-container .branch-table tbody tr td:last-child button.members-btn {
  background-color: var(--primary-color);
  color: white;
}
.branch-container .branch-table tbody tr td:last-child button.members-btn:hover {
  opacity: 0.9;
}
.branch-container .branch-table tbody tr:last-child td {
  border-bottom: none;
}
.branch-container .no-data {
  text-align: center;
  padding: calc(var(--spacing-unit) * 3);
  font-size: 1rem;
  color: var(--text-color-medium);
  border: 1px dashed var(--border-color);
  background: var(--card-bg);
  border-radius: 0.5rem;
  margin-top: 1rem;
}
.branch-container .view-toggle-wrapper {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  margin-left: auto;
  padding: 1rem 0;
}
.branch-container .view-toggle-wrapper .view-toggle-btn {
  display: flex;
  align-items: center;
  padding: 0.3rem 0.6rem;
  font-size: 0.9rem;
  background-color: transparent;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  cursor: pointer;
  color: #374151;
}
.branch-container .view-toggle-wrapper .view-toggle-btn.active {
  background-color: #f3f4f6;
  font-weight: 600;
}
.branch-container .view-toggle-wrapper .view-toggle-btn svg {
  margin-right: 4px;
}
.branch-container .no-branch-found {
  text-align: center;
  font-size: 1.1rem;
  color: var(--text-color-medium);
  padding: calc(var(--spacing-unit) * 3) calc(var(--spacing-unit) * 2);
  background: var(--card-bg);
  border-radius: 0.75rem;
  border: 1px dashed var(--border-color);
  box-shadow: 0 2px 5px var(--shadow-light);
  margin-top: calc(var(--spacing-unit) * 2);
  grid-column: 1/-1;
}

@media (max-width: 640px) {
  .branch-container .branch-card .branch-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.75rem;
  }
  .branch-container .branch-card .branch-header .branch-actions {
    align-self: stretch;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  .branch-container .branch-card .branch-header .branch-actions .branch-action-btn {
    width: auto;
    height: auto;
    padding: 0.4rem 0.6rem;
    font-size: 0.8rem;
    border-radius: 0.375rem;
  }
  .branch-container .branch-card .branch-header .branch-title-wrapper .branch-name::after {
    width: 60%;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Branch/Branch.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,yBAAA;EACA,aAAA;EACA,gBAAA;AACF;AACE;EACE,uBAAA;EACA,yBAAA;EACA,qBAAA;EACA,eAAA;EACA,eAAA;AACJ;AACI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AACN;AACM;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AACR;AACQ;EACE,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;AACV;AAEQ;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAAV;AAIM;EACE,aAAA;EACA,eAAA;EACA,WAAA;EACA,yBAAA;AAFR;AAIQ;EAGE,YAAA;EACA,YAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,iCAAA;AAJV;AAOQ;EACE,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AALV;AAMU;EACE,yBAAA;EACA,YAAA;AAJZ;AAQQ;;;EAGE,uBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;AANV;AASQ;EACE,yBAAA;AAPV;AAUQ;EACE,sCAAA;AARV;AAWQ;EACE,sCAAA;EACA,6BAAA;AATV;AAWU;EACE,YAAA;AATZ;AAeI;EACE,kBAAA;EACA,mBAAA;EACA,cAAA;AAbN;AAeM;EACE,cAAA;EACA,gBAAA;AAbR;AAgBM;EACE,qBAAA;EACA,WAAA;AAdR;AA6BE;EACE,aAAA;EACA,4DAAA;EACA,SAAA;EACA,gBAAA;AA3BJ;AAgCE;EACE,WAAA;EACA,yBAAA;EACA,gCAAA;EACA,qCAAA;EACA,qBAAA;EACA,gBAAA;EACA,yCAAA;EACA,kBAAA;AA9BJ;AAgCI;EACE,yBAAA;AA9BN;AAgCM;EACE,gBAAA;EACA,aAAA;EACA,6BAAA;EACA,gBAAA;EACA,4CAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;AA9BR;AAmCM;EACE,sCAAA;AAjCR;AAmCQ;EACE,yBAAA;AAjCV;AAoCQ;EACE,oBAAA;EACA,+BAAA;EACA,4CAAA;AAlCV;AAoCU;EACE,6BAAA;EACA,gBAAA;AAlCZ;AAqCU;EACE,0BAAA;EACA,gBAAA;AAnCZ;AAuCQ;EACE,mBAAA;AArCV;AAwCU;EACE,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,sCAAA;AAtCZ;AAwCY;EACE,yBAAA;EACA,YAAA;AAtCd;AAwCc;EAEE,YAAA;AAvChB;AA2CY;EACE,yBAAA;EACA,YAAA;AAzCd;AA4CY;EACE,sCAAA;EACA,YAAA;AA1Cd;AA6CY;EACE,sCAAA;EACA,YAAA;AA3Cd;AA6Cc;EACE,YAAA;AA3ChB;AAkDM;EACE,mBAAA;AAhDR;AAqDE;EACE,kBAAA;EACA,sCAAA;EACA,eAAA;EACA,+BAAA;EACA,sCAAA;EACA,0BAAA;EACA,qBAAA;EACA,gBAAA;AAnDJ;AAuDE;EACE,aAAA;EACA,WAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;AArDJ;AAuDI;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,iBAAA;EACA,6BAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AArDN;AAuDM;EACE,yBAAA;EACA,gBAAA;AArDR;AAwDM;EACE,iBAAA;AAtDR;AA2DE;EAKU,kBAAA;EACA,iBAAA;EACA,+BAAA;EACA,oEAAA;EACA,0BAAA;EACA,sBAAA;EACA,sCAAA;EACA,yCAAA;EACA,yCAAA;EACA,iBAAA;AA7DZ;;AAmEA;EAGM;IACE,sBAAA;IACA,uBAAA;IACA,YAAA;EAlEN;EAoEM;IACE,mBAAA;IACA,2BAAA;IACA,eAAA;EAlER;EAoEQ;IACE,WAAA;IACA,YAAA;IACA,sBAAA;IACA,iBAAA;IACA,uBAAA;EAlEV;EAuEQ;IACE,UAAA;EArEV;AACF","sourcesContent":[".branch-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1rem;\r\n  background-color: #f8f9fa;\r\n  padding: 15px;\r\n  margin-top: 1rem;\r\n\r\n  .branch-card {\r\n    background-color: white;\r\n    border: 1px solid #c4c4c4;\r\n    border-radius: 0.3rem;\r\n    padding: 1.5rem;\r\n    cursor: pointer;\r\n\r\n    .branch-header {\r\n      display: flex;\r\n      justify-content: space-between;\r\n      align-items: center;\r\n      margin: 0;\r\n\r\n      .branch-title-wrapper {\r\n        display: flex;\r\n        flex-direction: column;\r\n        gap: 0.6rem;\r\n\r\n        .branch-label {\r\n          background-color: #e5e7eb;\r\n          color: #374151;\r\n          font-size: 0.75rem;\r\n          font-weight: 500;\r\n          padding: 0.2rem 0.5rem;\r\n          border-radius: 0.25rem;\r\n          width: fit-content;\r\n          text-transform: uppercase;\r\n          letter-spacing: 0.5px;\r\n        }\r\n\r\n        .branch-name {\r\n          font-size: 1.2rem;\r\n          font-weight: 700;\r\n          color: #1f2937;\r\n          position: relative;\r\n        }\r\n      }\r\n\r\n      .branch-actions {\r\n        display: flex;\r\n        flex-wrap: wrap;\r\n        gap: 0.5rem;\r\n        justify-content: flex-end;\r\n\r\n        .branch-action-btn {\r\n          // background-color: var(--warning-color);\r\n          // color: white;\r\n          color: black;\r\n          border: none;\r\n          border-radius: 9999px;\r\n          width: 2rem;\r\n          height: 2rem;\r\n          display: flex;\r\n          align-items: center;\r\n          justify-content: center;\r\n          cursor: pointer;\r\n          transition: background-color 0.2s;\r\n        }\r\n\r\n        .edit-branch {\r\n          margin-right: 0.5rem;\r\n          padding: 0.3rem 0.6rem;\r\n          font-size: 0.85rem;\r\n          border: none;\r\n          border-radius: 6px;\r\n          cursor: pointer;\r\n          &:hover{\r\n            background-color: #f8f9fa;\r\n            opacity: 0.9;\r\n          }\r\n        }\r\n\r\n        .manual-add,\r\n        .spreadsheet-add,\r\n        .members-action {\r\n          border-radius: 0.375rem;\r\n          padding: 0.4rem 0.75rem;\r\n          font-size: 0.875rem;\r\n          font-weight: 500;\r\n          color: white;\r\n          display: flex;\r\n          align-items: center;\r\n          justify-content: center;\r\n          height: auto;\r\n          width: auto;\r\n        }\r\n\r\n        .manual-add {\r\n          background-color: #2E8B57;\r\n        }\r\n\r\n        .spreadsheet-add {\r\n          background-color: var(--primary-color);\r\n        }\r\n\r\n        .members-action {\r\n          background-color: var(--primary-color);\r\n          transition: opacity 0.2s ease;\r\n\r\n          &:hover {\r\n            opacity: 0.9;\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    .branch-meta {\r\n      margin-top: 0.5rem;\r\n      font-size: 0.875rem;\r\n      color: #6b7280;\r\n\r\n      .branch-detail-value {\r\n        color: #135bc0;\r\n        font-weight: 600;\r\n      }\r\n\r\n      .branch-meta-separator {\r\n        display: inline-block;\r\n        width: 24px;\r\n      }\r\n    }\r\n\r\n    // &:hover{\r\n    //   .branch-header{\r\n    //     .branch-actions{\r\n    //       .edit-branch{\r\n    //         opacity: 1;\r\n    //       }\r\n    //     }\r\n    //   }\r\n    // }\r\n  }\r\n\r\n  .branch-grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(auto-fill, minmax(900px, 1fr));\r\n    gap: 1rem;\r\n    margin-top: 1rem;\r\n  }\r\n\r\n\r\n\r\n  .branch-table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    background-color: var(--card-bg);\r\n    border: 1px solid var(--border-color);\r\n    border-radius: 0.5rem;\r\n    overflow: hidden;\r\n    box-shadow: 0 2px 6px var(--shadow-light);\r\n    font-size: 0.95rem;\r\n\r\n    thead {\r\n      background-color: #f1f5f9;\r\n\r\n      th {\r\n        text-align: left;\r\n        padding: 1rem;\r\n        color: var(--text-color-dark);\r\n        font-weight: 600;\r\n        border-bottom: 1px solid var(--border-color);\r\n        text-transform: uppercase;\r\n        letter-spacing: 0.5px;\r\n        font-size: 0.85rem;\r\n      }\r\n    }\r\n\r\n    tbody {\r\n      tr {\r\n        transition: background-color 0.2s ease;\r\n\r\n        &:hover {\r\n          background-color: #f9fafb;\r\n        }\r\n\r\n        td {\r\n          padding: 0.9rem 1rem;\r\n          color: var(--text-color-medium);\r\n          border-bottom: 1px solid var(--border-color);\r\n\r\n          &.bold {\r\n            color: var(--text-color-dark);\r\n            font-weight: 600;\r\n          }\r\n\r\n          &.highlight {\r\n            color: var(--accent-color);\r\n            font-weight: 700;\r\n          }\r\n        }\r\n\r\n        td:last-child {\r\n          white-space: nowrap;\r\n          // text-align: right;\r\n\r\n          button {\r\n            margin-left: 0.3rem;\r\n            padding: 0.35rem 0.7rem;\r\n            font-size: 0.8rem;\r\n            border-radius: 0.375rem;\r\n            border: none;\r\n            cursor: pointer;\r\n            transition: background-color 0.2s ease;\r\n\r\n            &.edit-btn {\r\n              background-color: #17a2b8;\r\n              color: white;\r\n\r\n              &:hover {\r\n                //background-color: #4b5563;\r\n                opacity: 0.9;\r\n              }\r\n            }\r\n\r\n            &.manual-btn {\r\n              background-color: #2E8B57;\r\n              color: white;\r\n            }\r\n\r\n            &.spreadsheet-btn {\r\n              background-color: var(--primary-color);\r\n              color: white;\r\n            }\r\n\r\n            &.members-btn {\r\n              background-color: var(--primary-color);\r\n              color: white;\r\n\r\n              &:hover {\r\n                opacity: 0.9;\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n\r\n      tr:last-child td {\r\n        border-bottom: none;\r\n      }\r\n    }\r\n  }\r\n\r\n  .no-data {\r\n    text-align: center;\r\n    padding: calc(var(--spacing-unit) * 3);\r\n    font-size: 1rem;\r\n    color: var(--text-color-medium);\r\n    border: 1px dashed var(--border-color);\r\n    background: var(--card-bg);\r\n    border-radius: 0.5rem;\r\n    margin-top: 1rem;\r\n  }\r\n\r\n\r\n  .view-toggle-wrapper {\r\n    display: flex;\r\n    gap: 0.5rem;\r\n    align-items: center;\r\n    margin-left: auto;\r\n    padding: 1rem 0;\r\n\r\n    .view-toggle-btn {\r\n      display: flex;\r\n      align-items: center;\r\n      padding: 0.3rem 0.6rem;\r\n      font-size: 0.9rem;\r\n      background-color: transparent;\r\n      border: 1px solid #d1d5db;\r\n      border-radius: 4px;\r\n      cursor: pointer;\r\n      color: #374151;\r\n\r\n      &.active {\r\n        background-color: #f3f4f6;\r\n        font-weight: 600;\r\n      }\r\n\r\n      svg {\r\n        margin-right: 4px;\r\n      }\r\n    }\r\n  }\r\n\r\n  .no-branch-found {\r\n    // padding: 1rem;\r\n    // text-align: center;\r\n    // color: #6b7280;\r\n    // font-size: 0.95rem;\r\n            text-align: center;\r\n            font-size: 1.1rem;\r\n            color: var(--text-color-medium);\r\n            padding: calc(var(--spacing-unit) * 3) calc(var(--spacing-unit) * 2);\r\n            background: var(--card-bg);\r\n            border-radius: 0.75rem;\r\n            border: 1px dashed var(--border-color);\r\n            box-shadow: 0 2px 5px var(--shadow-light);\r\n            margin-top: calc(var(--spacing-unit) * 2);\r\n            grid-column: 1 / -1;\r\n  }\r\n\r\n\r\n}\r\n\r\n@media (max-width: 640px) {\r\n  .branch-container {\r\n    .branch-card {\r\n      .branch-header {\r\n        flex-direction: column;\r\n        align-items: flex-start;\r\n        gap: 0.75rem;\r\n\r\n        .branch-actions {\r\n          align-self: stretch;\r\n          justify-content: flex-start;\r\n          flex-wrap: wrap;\r\n\r\n          .branch-action-btn {\r\n            width: auto;\r\n            height: auto;\r\n            padding: 0.4rem 0.6rem;\r\n            font-size: 0.8rem;\r\n            border-radius: 0.375rem;\r\n          }\r\n        }\r\n\r\n        .branch-title-wrapper {\r\n          .branch-name::after {\r\n            width: 60%;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
